import { Component, OnInit, Input } from '@angular/core';
import { OHNElement } from '../../../models/ohn-instances';

@Component({
  selector: 'app-yes-no-element-config',
  templateUrl: './yes-no-element-config.component.html',
  styleUrls: ['./yes-no-element-config.component.scss'],
})
export class YesNoElementConfigComponent implements OnInit {

	@Input() el: OHNElement;

  constructor() { }

  ngOnInit() {}

}
